/* eslint-disable import/first,no-func-assign */
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgPodcastMicrophoneSolid = props => /*#__PURE__*/React.createElement("svg", _extends({}, props, {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 17",
  "aria-hidden": !props['aria-label'],
  focusable: "false"
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#podcast-microphone-solid_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.5 13.5h-1v2.798h1V13.5Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.5 15.5h-5v1h5v-1ZM8 14a4.756 4.756 0 0 1-4.75-4.75h.973A3.78 3.78 0 0 0 8 13.027a3.78 3.78 0 0 0 3.777-3.777h.973A4.756 4.756 0 0 1 8 14Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8 12.25c-1.655 0-3-1.41-3-3.144V4.394C5 2.66 6.345 1.25 8 1.25s3 1.41 3 3.144V5.5H8.25v.75H11v1.5H8.25v.75H11v.606c0 1.734-1.345 3.144-3 3.144Z"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "podcast-microphone-solid_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 .5h16v16H0z"
}))));

export default SvgPodcastMicrophoneSolid;